import styled from "styled-components";
import { StyledHomePageSectionBlock } from "../styledHomePage";
import { motion } from "framer-motion";

export const StyledHomePageHowItWorkSection = styled.div`
  overflow: hidden;
  padding-bottom: 50px;
  @media(max-width: 576px) {
    padding-bottom: 0;
  }
`;

export const StyledHomePageHowItWorkBlock = styled(StyledHomePageSectionBlock)`
  padding: 0 15px;  
  position: relative;
  
  @media(min-width: 992px) {
    &:before {
      width: 100%;
      max-width: 495px;
      height: 495px;
      content: '';
      position: absolute;
      top: -300px;
      right: -220px;
      border-radius: 50%;
      background: rgba(23, 37, 160, 0.15);
      filter: blur(100px);
      user-select: none;
    }
  }

  @media(max-width: 576px) {
    .main-title {
      margin: 0 auto 20px;
      position: relative;
      font-size: 30px;
      text-align: center;
      line-height: 30px;
      z-index: 10;
    }
  }
`;

export const StyledContentParentWrapperDesktop = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 330px;

  justify-content: space-between;
  align-items: center;
  position: relative;
  .right-block {
    padding-top: 15px;
    display: flex;
    flex-direction: column;
    gap: 170px;
  }

  .center-block {
    max-width: 475px;
    max-height: 1600px;
    position: absolute;
    right: -25px;
    top: 0;
    transform: translateX(-50%);
  }

  .left-block {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 170px;

    .try-subscription-block {
      position: absolute;
      bottom: -170px;
      left: 90px;

      &:after {
        content: "";
        width: 360px;
        height: 170px;
        position: absolute;
        top: -50px;
        left: -60px;
        background: rgba(155, 104, 228, 0.3);
        filter: blur(50px);
      }

      .try-subscription-action {
        padding: 12px 30px;
        position: relative;
        line-height: 22px;
        z-index: 10;
      }

      .circle-decoration-try-subscription-block {
        position: absolute;
        left: 100px;
        top: 122px;

        .circle-decoration-element {
          position: absolute;
          z-index: 10;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: rgba(155, 104, 228, 0.3);
          filter: blur(7.5px);
          transform: matrix(-1, 0, 0, 1, 0, 0);
        }
        &:after {
          content: "";
          width: 20px;
          height: 20px;
          position: absolute;
          left: 15px;
          top: 15px;
          border-radius: 50%;
          background: linear-gradient(360deg, #1725A0 -9.06%, #9B68E4 100%);
          box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.25);
          z-index: 10;
        }
      }
    }
  }

  @media (max-width: 1200px) {
    gap: 20px;
    .right-block {
      padding-top: 0;
    }
    .circle-decoration-try-subscription-block {
      display: none;
    }
    .center-block {
      display: none;
    }
  }
  @media (max-width: 768px) {
    display: none;
  }
`

export const StyledContentParentWrapperResponse = styled.div`

  .chat-image-btn {
    padding: 5px 17px;
    background: linear-gradient(195.8deg, #FFFFFF -2.63%, #F3F2F2 113.92%, #F3F2F2 113.94%);
    color: #646464;
    font-size: 16px;
    font-weight: 300;
    border-radius: 7px;
    border: 1px solid transparent;

    &:hover {
      background: linear-gradient(195.8deg, #FFFFFF -2.63%, #F3F2F2 113.92%, #F3F2F2 113.94%);
      border: 1px solid #DBC9F6;
      box-shadow: 2px 2px 15px rgb(0 0 0 / 20%);
      border-radius: 7px;
    }
  }

  @media (min-width: 768px) {
    display: none;
  }

  @media(max-width: 576px) {
    margin: 0 auto;
    max-width: max-content;
    position: relative;
    z-index: 10;
  }

  .try-subscription-action {
    padding: 12px 14px;
    margin: 50px auto 0;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
  }
  
`

export const StyledContentInfoResponse = styled.div`
 
  margin: 0 auto;

  @media(min-width: 576px) {
    .main-description {
      font-size: 16px;
      line-height: 25px;
    }
  }
 
`

export const StyledContentBlockResponseActionBts = styled.div`
  padding-top: 20px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`

export const StyledContentBlockResponse = styled.div`
  text-align: center;
 img {
   box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.15);
   border-radius: 20px;
 }
  @media(min-width: 576px) {
    img {
      width: 75%;
      height: 75%;
    }
  }
`


export const StyledHowItWorkContent = styled(motion.div)`
  position: relative;
  max-width: 416px;
  border-radius: 15px;
  z-index: 10;
  transition: all 0.2s linear;
  
  .circle-decoration-block-right-block {
    position: absolute;
    left: 111%;
    top: 21px;
    
    .circle-decoration-element {
      position: absolute;
      z-index: 10;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background: rgba(155, 104, 228, 0.3);
      filter: blur(7.5px);
      transform: matrix(-1, 0, 0, 1, 0, 0);
    }
    &:after {
      content: "";
      width: 20px;
      height: 20px;
      position: absolute;
      left: 15px;
      top: 15px;
      border-radius: 50%;
      background: #E6E0EF;
      box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.25);
      z-index: 10;
    }
  }

  
  .circle-decoration-block-left-block {
    position: absolute;
    right: 127%;
    top: 50px;

    .circle-decoration-element {
      position: absolute;
      z-index: 10;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background: rgba(155, 104, 228, 0.3);
      filter: blur(7.5px);
      transform: matrix(-1, 0, 0, 1, 0, 0);
    }
    &:before {
      content: "";
      width: 20px;
      height: 20px;
      position: absolute;
      left: 15px;
      top: 15px;
      border-radius: 50%;
      background: #E6E0EF;
      box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.25);
      z-index: 12;
    }
  }

  
  
  &:hover {
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.15);
    .circle-decoration-block-right-block {
        &:after {
          background: linear-gradient(360deg, #1725A0 -9.06%, #9B68E4 100%);
          box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.25);
        }
    }
    .circle-decoration-block-left-block {
      &:before {
        background: linear-gradient(360deg, #1725A0 -9.06%, #9B68E4 100%);
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.25);
      }
    }
  }



  @media (max-width: 1200px) {
    .center-block {
      display: none;
    }
    .circle-decoration-block-right-block, .circle-decoration-block-left-block {
      display: none;
    }
  }
`

export const StyledContentCardBlock = styled.div`
  padding: 50px 35px 35px 30px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  background: linear-gradient(195.8deg, #FFFFFF -2.63%, #F3F2F2 113.92%, #F3F2F2 113.94%);
  border: 1px solid rgba(155, 104, 228, 0.3);
  border-radius: 15px;
  position: relative;
  
  @media (max-width: 992px) {
    padding: 35px 25px 25px 20px;
  }
`

export const StyledCardBlockInfo = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 30px;
`
export const StyledCardBlockImage = styled.div`
  display: flex;
  justify-content: center;
`